




















































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import PolicyFormRecordType from '@/modules/Policy/components/forms/PolicyFormRecordType.vue'
import PolicyFormCarrierProduct from '@/modules/Policy/components/forms/PolicyFormCarrierProduct.vue'
import PolicyFormAccount from '@/modules/Policy/components/forms/PolicyFormAccount.vue'
import PolicyFormInfo from '@/modules/Policy/components/forms/PolicyFormInfo.vue'
import PolicyFormSource from '@/modules/Policy/components/forms/PolicyFormSource.vue'
import PolicyFormAdditional from '@/modules/Policy/components/forms/PolicyFormAdditional.vue'
import PolicyFormCarrier from '@/modules/Policy/components/forms/PolicyFormCarrier.vue'
import PolicyFormPremium from '@/modules/Policy/components/forms/PolicyFormPremium.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import RecordTypesHandler from '@/mixins/record-types'
import { newPolicy, editPolicy } from '@/modules/Policy/gql/policy.gql'
import { Case } from '@/modules/Case/interfaces/case'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { IPolicyRecordTypeInput, IPolicyCarrierProductInput, IPolicyAccountInput, IPolicyInfoInput, IPolicySourceInput, IPolicyAdditionalInfoInput, IPolicyPremiumInput, IPolicyCarrierInput, IPolicyInput } from '@/modules/Policy/interfaces/policy-form'
import {
  statusKeys,
  policyTypeKeys, policyTypeValues, policyType,
  billingTypeKeys,
  payerTypeKeys
} from '@/modules/Policy/helpers/policy'
import { QuoteWithPremium } from '@/modules/Quote/interfaces/quote-with-premium'
import { states } from '@/utils/us_states'

@Component({
  components: {
    PolicyFormRecordType,
    PolicyFormCarrierProduct,
    PolicyFormAccount,
    PolicyFormInfo,
    AppDialog,
    PolicyFormSource,
    PolicyFormAdditional,
    PolicyFormCarrier,
    PolicyFormPremium,
    AppSteps,
    AppTextarea
  }
})
export default class PolicyForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Object as () => Account }) readonly accountInfo!: Account
  @Prop({ type: Object as () => Contact }) readonly contactInfo!: Contact
  @Prop({ type: Object as () => CarrierProduct }) readonly carrierProductInfo!: CarrierProduct
  @Prop({ type: Object as () => Producer }) readonly producerInfo!: Producer
  @Prop({ type: Object as () => QuoteWithPremium }) readonly quoteInfo!: QuoteWithPremium
  @Prop(Boolean) readonly showRedirect!: boolean

  showDialog = false
  loading = false

  recordTypeIndex = 0
  stepIndex = 0
  steps = [
    ['Record Type', 740, 561],
    ['Insurance Product', 770, 301],
    ['Account Info', 770, 301],
    ['Policy Info', 770, 591],
    ['Choose Carrier', 770, 301],
    ['Premium Info', 770, 940],
    ['Source Info', 770, 301],
    ['Additional Info', 770, 561]
  ]

  recordTypeInput: IPolicyRecordTypeInput = {
    recordType: {}
  }

  carrierProductInput: IPolicyCarrierProductInput = {
    carrierProduct: {}
  }

  accountInput: IPolicyAccountInput = {
    account: {},
    primaryContact: {}
  }

  infoInput: IPolicyInfoInput = {
    policyName: '',
    policyNumber: '',
    typeIdx: -1,
    statusIdx: -1,
    quote: {},
    priorTerm: {},
    originalInceptionDate: '',
    cancelDate: '',
    nonRenew: false,
    writingAgent: {}
  }

  carrierInput: IPolicyCarrierInput = {
    carrier: {},
    ga: {}
  }

  premiumInput: IPolicyPremiumInput = {
    effectiveDate: '',
    expirationDate: '',
    term: 0,
    bindDate: '',
    premium: '0',
    agencyFee: '0',
    carrierPolicyFee: '0',
    inspectionFee: '0',
    stampingFee: '0',
    taxesFee: '0',
    brokerFee: '0',
    billingTypeIdx: 0,
    commission: '0',
    installmentPlan: 1,
    payerTypeIdx: 0
  }

  sourceInput: IPolicySourceInput = {
    source: {},
    book: {}
  }

  originInput: IPolicyInput = {
    recordTypeInput: {
      recordType: {}
    },
    carrierProductInput: {
      carrierProduct: {}
    },
    accountInput: {
      account: {},
      primaryContact: {}
    },
    infoInput: {
      policyName: '',
      policyNumber: '',
      typeIdx: -1,
      statusIdx: -1,
      quote: {},
      priorTerm: {},
      originalInceptionDate: '',
      cancelDate: '',
      nonRenew: false,
      writingAgent: {}
    },
    sourceInput: {
      source: {},
      book: {}
    },
    carrierInput: {
      carrier: {},
      ga: {}
    },
    premiumInput: {
      effectiveDate: '',
      expirationDate: '',
      term: 0,
      bindDate: '',
      premium: '0',
      agencyFee: '0',
      carrierPolicyFee: '0',
      inspectionFee: '0',
      stampingFee: '0',
      taxesFee: '0',
      brokerFee: '0',
      billingTypeIdx: 0,
      commission: '0',
      installmentPlan: 1,
      payerTypeIdx: 0
    }
  }

  additionalInfoInput: IPolicyAdditionalInfoInput = {}

  endorsementNote = ''

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return this.recordTypeInput.recordType.name ? ' (' + this.recordTypeInput.recordType.name + ')' : ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.policy
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.policy ? 'Save' : 'Create'
  }

  get confirmRedirectAheadText () {
    return this.policy ? 'Save & Redirect' : 'Create & Redirect'
  }

  get canPost () {
    return this.stepIndex > 5 && this.stepIndex < 7
  }

  get showSaveAndRedirect () {
    return this.stepIndex > 5
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  @Watch('stepIndex')
  onStepChanged (val: number) {
    const {
      recordTypeInput: {
        recordType
      },
      accountInput: {
        account
      },
      infoInput: {
        typeIdx,
        policyName
      }
    } = this

    if (val !== 3 || !account.name || policyName) {
      return
    }

    const policyType = policyTypeValues[typeIdx] ? policyTypeValues[typeIdx] + '-' : ''
    const year = this.$moment.tz('America/New_York').year()

    this.infoInput.policyName = `${account.name}-${recordType.name}-Policy-${policyType}${year}`
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.policy) {
      this.initPolicy(this.policy)
    } else {
      this.clearForm()
    }

    if (this.accountInfo) {
      const { id, name, source } = this.accountInfo
      this.accountInput = {
        ...this.accountInput,
        account: {
          id: +id,
          name
        }
      }
      this.sourceInput = {
        ...this.sourceInput,
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        }
      }
    }

    if (this.carrierProductInfo) {
      this.carrierProductInput = {
        carrierProduct: {
          id: +this.carrierProductInfo.id,
          name: this.carrierProductInfo.name
        }
      }
    }

    if (this.caseInfo) {
      const {
        account: {
          id: accountId,
          name: accountName,
          book
        },
        source,
        recordType: {
          id: recordTypeId,
          name: recordTypeName
        },
        asset
      } = this.caseInfo
      this.accountInput = {
        ...this.accountInput,
        account: {
          id: +accountId,
          name: accountName
        }
      }
      this.sourceInput = {
        ...this.sourceInput,
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        },
        book: {
          id: book ? +book.id : undefined,
          name: book ? book.name : ''
        }
      }
      this.recordTypeInput = {
        ...this.recordTypeInput,
        recordType: {
          id: +recordTypeId,
          name: recordTypeName
        }
      }
      if (this.caseInfo.targetPolicy) {
        const { targetPolicy } = this.caseInfo
        this.initPolicy(targetPolicy)
        this.infoInput.priorTerm = {
          id: +targetPolicy.id,
          name: targetPolicy.policyName
        }
        this.infoInput.policyName += ' ' + policyType[this.caseInfo.type]
        if (targetPolicy.expirationDate) {
          this.premiumInput.effectiveDate = targetPolicy.expirationDate
          this.premiumInput.expirationDate = this.$moment.unix(targetPolicy.expirationDate).add(targetPolicy.term || 1, 'M').unix()
        }
      }
      this.infoInput.typeIdx = policyTypeKeys.findIndex(key => key === this.caseInfo.type)

      if (asset) {
        this.additionalInfoInput = {
          address1: asset.property.address1 ? asset.property.address1 : '',
          address2: asset.property.address2 ? asset.property.address2 : '',
          city: asset.property.city ? asset.property.city : '',
          zipCode: asset.property.zipCode ? asset.property.zipCode : '',
          state: asset.property.state ? states.findIndex(st => asset.property.state === st) : -1
        }
      }
    }

    if (this.contactInfo) {
      this.accountInput = {
        ...this.accountInput,
        primaryContact: {
          id: +this.contactInfo.id,
          name: this.contactInfo.name
        }
      }
    }

    if (this.producerInfo) {
      this.sourceInput = {
        ...this.sourceInput,
        source: {
          id: +this.producerInfo.id,
          name: this.producerInfo.name
        }
      }
    }

    if (this.quoteInfo) {
      const { quoteInfo: quote } = this
      const { caseInfo, priorTerm, account: { book }, originalInceptionDate, additionalInfoStr } = quote
      this.recordTypeInput = {
        recordType: {
          id: +quote.recordType.id,
          name: quote.recordType.name
        }
      }
      this.accountInput = {
        ...this.accountInput,
        account: {
          id: +quote.account.id,
          name: quote.account.name
        }
      }
      this.infoInput = {
        ...this.infoInput,
        originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : '',
        quote: {
          id: +this.quoteInfo.id,
          name: this.quoteInfo.name
        }
      }
      if (priorTerm) {
        this.initPolicy(priorTerm)
        this.infoInput.priorTerm = {
          id: +priorTerm.id,
          name: priorTerm.policyName
        }
        this.infoInput.policyName += ' ' + policyType[caseInfo ? caseInfo.type : '']
        if (priorTerm.expirationDate) {
          this.premiumInput.effectiveDate = priorTerm.expirationDate
          this.premiumInput.expirationDate = this.$moment.unix(priorTerm.expirationDate).add(priorTerm.term || 1, 'M').unix()
        }
      }
      if (caseInfo) {
        this.infoInput.typeIdx = policyTypeKeys.findIndex(key => key === caseInfo.type)
      }
      if (quote.carrierProduct) {
        this.carrierProductInput = {
          carrierProduct: {
            id: +quote.carrierProduct.id,
            name: quote.carrierProduct.name
          }
        }
      }
      if (quote.primaryContact) {
        this.accountInput = {
          ...this.accountInput,
          primaryContact: {
            id: +quote.primaryContact.id,
            name: quote.primaryContact.name
          }
        }
      }
      if (quote.source) {
        this.sourceInput = {
          ...this.sourceInput,
          source: {
            id: +quote.source.id,
            name: quote.source.name
          }
        }
      }
      if (quote.premiumInfo) {
        const { premiumInfo: {
          carrierName, carrierId,
          gaName, gaId,
          effectiveDate, expirationDate, term,
          premium, agencyFee, carrierPolicyFee, inspectionFee,
          stampingFee, taxesFee, brokerFee,
          billingType, commission, installmentPlan, bindDate, payerType
        } } = quote
        this.carrierInput = {
          carrier: {
            name: carrierName || '',
            id: carrierId ? +carrierId : undefined
          },
          ga: {
            name: gaName || '',
            id: gaId ? +gaId : undefined
          }
        }
        this.premiumInput = {
          effectiveDate: effectiveDate ? effectiveDate + '' : '',
          expirationDate: expirationDate ? expirationDate + '' : '',
          term: term || 1,
          bindDate: bindDate ? bindDate + '' : effectiveDate ? effectiveDate + '' : '',
          premium: premium || '0',
          agencyFee: agencyFee || '0',
          carrierPolicyFee: carrierPolicyFee || '0',
          inspectionFee: inspectionFee || '0',
          stampingFee: stampingFee || '0',
          taxesFee: taxesFee || '0',
          brokerFee: brokerFee || '0',
          billingTypeIdx: billingTypeKeys.findIndex(key => key === billingType),
          commission: commission ? commission + '' : '0',
          installmentPlan: installmentPlan || 1,
          payerTypeIdx: payerTypeKeys.findIndex(key => key === payerType)
        }
      }

      if (book) {
        this.sourceInput = {
          ...this.sourceInput,
          book: {
            id: +book.id,
            name: book.name
          }
        }
      }

      if (additionalInfoStr) {
        const additionalInfo = JSON.parse(additionalInfoStr)
        this.additionalInfoInput = { ...additionalInfo }
      }
    }

    this.originInput = {
      recordTypeInput: {
        ...this.recordTypeInput
      },
      carrierProductInput: {
        ...this.carrierProductInput
      },
      accountInput: {
        ...this.accountInput
      },
      infoInput: {
        ...this.infoInput
      },
      sourceInput: {
        ...this.sourceInput
      },
      carrierInput: {
        ...this.carrierInput
      },
      premiumInput: {
        ...this.premiumInput
      }
    }
  }

  initPolicy (policy: Policy) {
    const {
      policyName, type, status, originalInceptionDate,
      policyNumber, additionalInfoStr, cancelDate, nonRenew,
      effectiveDate, expirationDate,
      installmentPlan,
      billingType, term, bindDate, premium, agencyFee, brokerFee, carrierPolicyFee, inspectionFee, taxesFee, stampingFee, productCommissionOverride, payerType,
      recordType, account, primaryContact, book, carrier, carrierProduct, generalAgent, source,
      writingAgents,
      inheritPolicies
    } = policy
    this.recordTypeInput = {
      recordType: {
        id: +recordType.id,
        name: recordType.name
      }
    }
    this.carrierProductInput = {
      carrierProduct: {
        id: carrierProduct ? +carrierProduct.id : undefined,
        name: carrierProduct ? carrierProduct.name : ''
      }
    }
    this.accountInput = {
      account: {
        id: +account.id,
        name: account.name
      },
      primaryContact: {
        id: primaryContact ? +primaryContact.id : undefined,
        name: primaryContact ? primaryContact.name : ''
      }
    }
    this.infoInput = {
      ...this.infoInput,
      policyName,
      policyNumber,
      cancelDate: cancelDate ? cancelDate + '' : '',
      nonRenew,
      typeIdx: policyTypeKeys.findIndex(key => key === type),
      statusIdx: statusKeys.findIndex(key => key === status),
      priorTerm: {
        id: inheritPolicies && inheritPolicies.fromPolicy ? +inheritPolicies.fromPolicy.id : undefined,
        name: inheritPolicies && inheritPolicies.fromPolicy ? inheritPolicies.fromPolicy.policyName : ''
      },
      originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : '',
      writingAgent: {
        id: writingAgents.length ? +writingAgents[0].id : undefined,
        name: writingAgents.length ? writingAgents[0].username : ''
      }
    }
    this.carrierInput = {
      carrier: {
        name: carrier ? carrier.name : '',
        id: carrier ? +carrier.id : undefined
      },
      ga: {
        name: generalAgent ? generalAgent.name : '',
        id: generalAgent ? +generalAgent.id : undefined
      }
    }
    this.premiumInput = {
      effectiveDate: effectiveDate ? effectiveDate + '' : '',
      expirationDate: expirationDate ? expirationDate + '' : '',
      term: term || 1,
      bindDate: bindDate || '',
      premium: premium || '0',
      agencyFee: agencyFee || '0',
      carrierPolicyFee: carrierPolicyFee || '0',
      inspectionFee: inspectionFee || '0',
      stampingFee: stampingFee || '0',
      taxesFee: taxesFee || '0',
      brokerFee: brokerFee || '0',
      billingTypeIdx: billingTypeKeys.findIndex(key => key === billingType),
      commission: productCommissionOverride ? productCommissionOverride + '' : '0',
      installmentPlan: installmentPlan || 1,
      payerTypeIdx: payerTypeKeys.findIndex(key => key === payerType)
    }
    this.sourceInput = {
      source: {
        id: source ? +source.id : undefined,
        name: source ? source.name : ''
      },
      book: {
        id: book ? +book.id : undefined,
        name: book ? book.name : ''
      }
    }
    if (additionalInfoStr) {
      const additionalInfo = JSON.parse(additionalInfoStr)
      this.additionalInfoInput = { ...additionalInfo }
    }
  }

  initSource (account: Account) {
    const { sourceInput } = this

    if (sourceInput.source && sourceInput.source.id) {
      return
    }
    if (account && account.source) {
      this.sourceInput.source = {
        id: +account.source.id,
        name: account.source.name
      }
    }
  }

  handleStepClick (index: number) {
    if (!this.policy) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  async handleRedirectConfirm (event: Event) {
    const res = await this.handleConfirm(event, true)
    if (res) {
      this.$router.push({
        name: 'PolicyDetailDetail',
        params: {
          id: res
        }
      })
    }
  }

  async handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.policy && !this.caseInfo) {
        return this.handleUpdate()
      } else {
        return this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    } else {
      this.showDialog = false
    }
  }

  async handleCreate () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      carrierProductInput: { carrierProduct: { id: carrierProductId } },
      accountInput: { account: { id: accountId }, primaryContact: { id: primaryContactId } },
      infoInput: {
        policyName, policyNumber, typeIdx, statusIdx,
        priorTerm: { id: priorTermId },
        originalInceptionDate,
        quote: { id: quoteId },
        cancelDate, nonRenew,
        writingAgent: { id: writingAgentId }
      },
      sourceInput: {
        source: { id: sourceId },
        book: { id: bookId }
      },
      carrierInput: {
        carrier: { id: carrierId },
        ga: { id: gaId }
      },
      premiumInput: {
        term, installmentPlan,
        effectiveDate, expirationDate, bindDate,
        premium, agencyFee, carrierPolicyFee, inspectionFee, stampingFee, brokerFee, taxesFee, commission, billingTypeIdx, payerTypeIdx
      },
      caseInfo,
      quoteInfo
    } = this

    const caseId = caseInfo
      ? +caseInfo.id
      : quoteInfo
        ? +quoteInfo.caseId
        : null

    try {
      const res = await this.$apollo.mutate({
        mutation: newPolicy,
        variables: {
          policyInput: {
            policyName,
            policyNumber,
            status: statusKeys[statusIdx],
            type: policyTypeKeys[typeIdx],
            effectiveDate: effectiveDate ? effectiveDate + '' : null,
            expirationDate: expirationDate ? expirationDate + '' : null,
            bindDate: bindDate ? bindDate + '' : null,
            originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : null,
            cancelDate: cancelDate ? cancelDate + '' : null,
            insuranceQuoteId: quoteId || null,
            nonRenew,
            additionalInfoStr: this.parseAdditionalInfo(),
            recordTypeId,
            accountId,
            primaryContactId: primaryContactId || null,
            sourceId: sourceId || null,
            carrierProductId: carrierProductId,
            priorTermId: priorTermId || null,
            bookId: bookId || null,
            carrierId: carrierId || null,
            gaId: gaId || null,
            caseId,
            premium: premium ? +premium : 0,
            agencyFee: agencyFee ? +agencyFee : 0,
            carrierPolicyFee: carrierPolicyFee ? +carrierPolicyFee : 0,
            inspectionFee: inspectionFee ? +inspectionFee : 0,
            stampingFee: stampingFee ? +stampingFee : 0,
            brokerFee: brokerFee ? +brokerFee : 0,
            taxesFee: taxesFee ? +taxesFee : 0,
            writingAgentIds: writingAgentId ? [+writingAgentId] : null,
            productCommissionOverride: commission ? +commission : 0,
            term: term ? Number(term) : null,
            billingType: billingTypeKeys[billingTypeIdx],
            installmentPlan: installmentPlan ? Number(installmentPlan) : null,
            payerType: payerTypeKeys[payerTypeIdx]
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new policy successfully')
      return res.data.newPolicy.id
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const input = this.generateUpdateInput()

    try {
      const res = await this.$apollo.mutate({
        mutation: editPolicy,
        variables: {
          policyId: +this.policy.id,
          policyInput: {
            ...input,
            additionalInfoStr: this.parseAdditionalInfo()
          }
        }
      })
      this.clearForm()
      this.onSuccess('Update policy successfully')
      return res.data.editPolicy.id
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  parseAdditionalInfo () {
    return JSON.stringify(this.additionalInfoInput, (key, value) => {
      return value === 0 ? '0' : (value || '')
    })
  }

  generateUpdateInput () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      carrierProductInput: { carrierProduct: { id: carrierProductId } },
      accountInput: { account: { id: accountId }, primaryContact: { id: primaryContactId } },
      infoInput: {
        policyName, policyNumber, typeIdx, statusIdx,
        priorTerm: { id: priorTermId },
        originalInceptionDate,
        quote: { id: quoteId },
        cancelDate, nonRenew,
        writingAgent: { id: writingAgentId }
      },
      sourceInput: {
        source: { id: sourceId },
        book: { id: bookId }
      },
      carrierInput: {
        carrier: { id: carrierId },
        ga: { id: gaId }
      },
      premiumInput: {
        term, installmentPlan,
        effectiveDate, expirationDate, bindDate,
        premium, agencyFee, carrierPolicyFee, inspectionFee, stampingFee, brokerFee, taxesFee, commission, billingTypeIdx, payerTypeIdx
      },
      originInput
    } = this

    const input: { [key:string]: unknown} = {}

    if (policyName !== originInput.infoInput.policyName) {
      input.policyName = policyName
    }

    if (policyNumber !== originInput.infoInput.policyNumber) {
      input.policyNumber = policyNumber
    }

    if (statusIdx !== originInput.infoInput.statusIdx) {
      input.status = statusKeys[statusIdx]
    }

    if (typeIdx !== originInput.infoInput.typeIdx) {
      input.type = policyTypeKeys[typeIdx]
    }

    if (effectiveDate !== originInput.premiumInput.effectiveDate) {
      input.effectiveDate = effectiveDate ? effectiveDate + '' : null
    }
    if (expirationDate !== originInput.premiumInput.expirationDate) {
      input.expirationDate = expirationDate ? expirationDate + '' : null
    }

    if (bindDate !== originInput.premiumInput.bindDate) {
      input.bindDate = bindDate ? bindDate + '' : null
    }

    if (originalInceptionDate !== originInput.infoInput.originalInceptionDate) {
      input.originalInceptionDate = originalInceptionDate ? originalInceptionDate + '' : null
    }
    if (cancelDate !== originInput.infoInput.cancelDate) {
      input.cancelDate = cancelDate ? cancelDate + '' : null
    }
    if (quoteId !== originInput.infoInput.quote.id) {
      input.insuranceQuoteId = quoteId || null
    }
    if (nonRenew !== originInput.infoInput.nonRenew) {
      input.nonRenew = nonRenew
    }
    if (recordTypeId !== originInput.recordTypeInput.recordType.id) {
      input.recordTypeId = recordTypeId
    }
    if (accountId !== originInput.accountInput.account.id) {
      input.accountId = accountId
    }
    if (primaryContactId !== originInput.accountInput.primaryContact.id) {
      input.primaryContactId = primaryContactId || null
    }
    if (sourceId !== originInput.sourceInput.source.id) {
      input.sourceId = sourceId || null
    }
    if (carrierProductId !== originInput.carrierProductInput.carrierProduct.id) {
      input.carrierProductId = carrierProductId || null
    }
    if (priorTermId !== originInput.infoInput.priorTerm.id) {
      input.priorTermId = priorTermId || null
    }
    if (bookId !== originInput.sourceInput.book.id) {
      input.bookId = bookId || null
    }
    if (carrierId !== originInput.carrierInput.carrier.id) {
      input.carrierId = carrierId || null
    }
    if (gaId !== originInput.carrierInput.ga.id) {
      input.gaId = gaId || null
    }
    if (premium !== originInput.premiumInput.premium) {
      input.premium = premium ? +premium : 0
    }
    if (agencyFee !== originInput.premiumInput.agencyFee) {
      input.agencyFee = agencyFee ? +agencyFee : 0
    }
    if (carrierPolicyFee !== originInput.premiumInput.carrierPolicyFee) {
      input.carrierPolicyFee = carrierPolicyFee ? +carrierPolicyFee : 0
    }
    if (inspectionFee !== originInput.premiumInput.inspectionFee) {
      input.inspectionFee = inspectionFee ? +inspectionFee : 0
    }
    if (stampingFee !== originInput.premiumInput.stampingFee) {
      input.stampingFee = stampingFee ? +stampingFee : 0
    }
    if (brokerFee !== originInput.premiumInput.brokerFee) {
      input.brokerFee = brokerFee ? +brokerFee : 0
    }
    if (taxesFee !== originInput.premiumInput.taxesFee) {
      input.taxesFee = taxesFee ? +taxesFee : 0
    }
    if (writingAgentId !== originInput.infoInput.writingAgent.id) {
      input.writingAgentIds = writingAgentId ? [+writingAgentId] : null
    }
    if (commission !== originInput.premiumInput.commission) {
      input.productCommissionOverride = commission ? +commission : 0
    }
    if (term !== originInput.premiumInput.term) {
      input.term = term ? Number(term) : null
    }
    if (billingTypeIdx !== originInput.premiumInput.billingTypeIdx) {
      input.billingType = billingTypeKeys[billingTypeIdx]
    }
    if (installmentPlan !== originInput.premiumInput.installmentPlan) {
      input.installmentPlan = installmentPlan ? Number(installmentPlan) : null
    }
    if (payerTypeIdx !== originInput.premiumInput.payerTypeIdx) {
      input.payerType = payerTypeKeys[payerTypeIdx]
    }

    return input
  }

  clearForm () {
    this.loading = false
    this.recordTypeInput = {
      recordType: {}
    }
    this.carrierProductInput = {
      carrierProduct: {}
    }
    this.accountInput = {
      account: {},
      primaryContact: {}
    }

    this.infoInput = {
      policyName: '',
      policyNumber: '',
      typeIdx: -1,
      statusIdx: -1,
      quote: {},
      priorTerm: {},
      originalInceptionDate: '',
      cancelDate: '',
      nonRenew: false,
      writingAgent: {}
    }

    this.sourceInput = {
      source: {},
      book: {}
    }

    this.premiumInput = {
      effectiveDate: '',
      expirationDate: '',
      term: 0,
      bindDate: '',
      premium: '0',
      agencyFee: '0',
      carrierPolicyFee: '0',
      inspectionFee: '0',
      stampingFee: '0',
      taxesFee: '0',
      brokerFee: '0',
      billingTypeIdx: 0,
      commission: '0',
      installmentPlan: 1,
      payerTypeIdx: 0
    }

    this.additionalInput = {}

    this.originInput = {
      recordTypeInput: {
        recordType: {}
      },
      carrierProductInput: {
        carrierProduct: {}
      },
      accountInput: {
        account: {},
        primaryContact: {}
      },
      infoInput: {
        policyName: '',
        policyNumber: '',
        typeIdx: -1,
        statusIdx: -1,
        quote: {},
        priorTerm: {},
        originalInceptionDate: '',
        cancelDate: '',
        nonRenew: false,
        writingAgent: {}
      },
      sourceInput: {
        source: {},
        book: {}
      },
      carrierInput: {
        carrier: {},
        ga: {}
      },
      premiumInput: {
        effectiveDate: '',
        expirationDate: '',
        term: 0,
        bindDate: '',
        premium: '0',
        agencyFee: '0',
        carrierPolicyFee: '0',
        inspectionFee: '0',
        stampingFee: '0',
        taxesFee: '0',
        brokerFee: '0',
        billingTypeIdx: 0,
        commission: '0',
        installmentPlan: 1,
        payerTypeIdx: 0
      }
    }
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (msg = '') {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
